import { d as defineCustomElement } from '../chunks/vidstack-B11i_cNc.js';
import { MediaAudioLayoutElement } from './vidstack-audio-layout-el.js';
import { MediaVideoLayoutElement } from './vidstack-video-layout-el.js';
import { MediaPlyrLayoutElement } from './plyr-layout-el.js';
import '../chunks/vidstack-Bf6opHxk.js';
import '../chunks/vidstack-CrYT4sOT.js';
import '../chunks/vidstack-CUVgUi9M.js';
import '../chunks/vidstack-NiSULkLR.js';
import '../chunks/vidstack-DDr92MCR.js';
import '../chunks/vidstack-CNLrsPpJ.js';
import '../chunks/vidstack-VrKElWm_.js';
import '../chunks/vidstack-BnqIpPdq.js';
import '../chunks/vidstack-CzvK2UwB.js';
import '../chunks/vidstack-COCzjeeM.js';
import '../chunks/vidstack-BPJwxG0c.js';
import '../chunks/vidstack-BSXZsAhp.js';
import '../chunks/vidstack-DM_McBs5.js';
import '../chunks/vidstack-ksPACRiU.js';
import '../chunks/vidstack-rsZGrNIW.js';

defineCustomElement(MediaAudioLayoutElement);
defineCustomElement(MediaVideoLayoutElement);
defineCustomElement(MediaPlyrLayoutElement);
